export const RandColor = () => {
  const randomColor = ["bg-white", "bg-secondary", "bg-warning"];
  return randomColor[Math.floor(Math.random() * randomColor.length)];
};
